<template>
  <div class="app-autocomplete">
    <b-field :label="label" :required="isRequired">
      <b-autocomplete
        ref="autoComplete"
        :data="data"
        :placeholder="placeholder || label"
        :field="field"
        :loading="loading"
        @typing="getAsyncData"
        @select="onSelect"
      >
        <template slot-scope="props">
          <div>{{ props.option[field] }}</div>
        </template>
      </b-autocomplete>
    </b-field>
    <div v-if="errors && errors.length" class="error">{{ errors[0] }}</div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';

export default {
  name: 'app-network-autocomplete',
  model: {
    prop: 'model',
    event: 'selected',
  },
  props: [
    'model',
    'errors',
    'label',
    'placeholder',
    'field',
    'searchFunction',
    'resourceIdFunction',
    'required',
  ],
  data: () => {
    return {
      data: [],
      selected: null,
      loading: false,
    };
  },
  methods: {
    getAsyncData: debounce(function (name) {
      if (name.lenght <= 3) return;

      this.loading = true;
      this.searchFunction(name)
        .then(({ data }) => (this.data = data))
        .catch((err) => {
          this.data = [];
          throw err;
        })
        .finally(() => (this.loading = false));
    }, 400),
    onSelect(option) {
      this.$emit('selected', option ? option.id : null);
    },
    loadResourceById(id) {
      this.loading = true;

      this.resourceIdFunction(id)
        .then(({ data: resource }) => {
          this.data = [resource];
          this.$refs.autoComplete.setSelected(resource);
        })
        .finally(() => (this.loading = false));
    },
    checkInArray(value) {
      const idx = this.data.findIndex((el) => el.id == value);
      if (idx === -1) this.loadResourceById(value);
    },
  },
  computed: {
    isRequired() {
      return this.required === '' || this.required;
    },
  },
  watch: {
    model(newValue) {
      if (!newValue) return;
      this.checkInArray(newValue);
    },
  },
  mounted() {
    if (this.model) this.checkInArray(this.model);
  },
};
</script>

<style lang="scss" scoped>
.app-autocomplete {
  .error {
    position: relative;
    top: -12px;
    font-size: 0.8em;
    color: #ff6363;
  }
}
</style>
